import { emptySplitApi } from './emptySplitApi';

import {
  GeneralObject,
  TGetOCancellationData,
  RetriggerPayload,
} from '../utils/types';

export const sapOrderCancellationFailureService =
  emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      getFailureRetailersList: builder.query<
        {
          data: TGetOCancellationData[];
          totalCount: number;
        },
        string
      >({
        query: (searchString) => ({
          method: 'GET',
          url: `order/sap/cancellation/retry${searchString}`,
        }),
        transformResponse: (
          data: TGetOCancellationData[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
      }),
      retriggerOFailure: builder.mutation<
        GeneralObject,
        RetriggerPayload
      >({
        query: (data) => ({
          method: 'POST',
          url: 'order/sap/cancellation/retrigger',
          data,
        }),
      }),
    }),
  });

export const {
  useGetFailureRetailersListQuery,
  useLazyGetFailureRetailersListQuery,
  useRetriggerOFailureMutation,
} = sapOrderCancellationFailureService;
